import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";
import { Link } from "gatsby";

function Banner(props) {
  return (
    <div className="services_location_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Flutter">
                <h1>Flutter App Development Company in Dubai</h1>
              </div>
              <p className="main_para">
                Take the mobile app experience to the next level by
                collaborating with our professional Flutter app development
                company. We have the expertise to design next-gen applications
                by using this exceptional framework - Flutter. Our team of
                skillful developers ensures a progressive growth of 65% on your
                ROI by deploying Flutter-based apps.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Build Your Flutter App!
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
